import { Outlet } from "react-router";
import Header from "../../../../../component/layout/header";
import useNav from "../../../../../script/tabingNavArray";

const MerchantsLayout = () => {
  const navList = useNav();
  let { merchantsBottomHeader, OperationsTopHeader } = navList;
  return (
    <div className="webBody">
      <Header
        bottomTabs={merchantsBottomHeader}
        topTabs={OperationsTopHeader}
      />
      <Outlet />
    </div>
  );
};

export default MerchantsLayout;
